var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bg"},[_c('div',{staticClass:"title-box",on:{"click":_vm.goSearch}},[_c('search-head',{attrs:{"isDisabled":true}})],1),_vm._v(" "),_c('div',{staticClass:"search-history-content"},[_c('goods-show',{attrs:{"goodsList":_vm.goodsList}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d31d70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/retail/goods.vue
// module id = null
// module chunks = 